import React from 'react';
import styled from 'styled-components';
import {
    SiAdobephotoshop,
    SiHtml5,
    SiCss3,
    SiFigma,
    SiStyledcomponents,
    SiNodedotjs,
    SiMongodb,
    SiVisualstudiocode,
} from 'react-icons/si';
import { BiLogoTypescript } from 'react-icons/bi';
import { DiReact } from 'react-icons/di';

const Container = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 2rem;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const ContainerFlex = styled.span`
    display: inline-flex;
    flex-direction: row;
    gap: 1.5rem;
    width: max-content;
    padding: 0 calc(2rem + 1vw);
    font-size: clamp(1.5rem, 2vw, 2.25rem);
`;

/*
TODO: make icons with new stack and also adaptive
*/

const StackGrind = () => {
    return (
        <Container className='exp'>
            <ContainerFlex>
                <SiAdobephotoshop size={'1em'} />
                <SiFigma size={'1em'} />
                <SiHtml5 size={'1em'} />
                <SiCss3 size={'1em'} />
                <SiStyledcomponents size={'1em'} />
                <DiReact size={'1em'} />
                <BiLogoTypescript size={'1em'} />
                <SiNodedotjs size={'1em'} />
                <SiMongodb size={'1em'} />
                <SiVisualstudiocode size={'1em'} />
            </ContainerFlex>
        </Container>
    );
};

export default StackGrind;
